// extracted by mini-css-extract-plugin
export default {"btn":"table-action-button_btn__6x1Wv"};